import React, { useEffect, createElement } from 'react';
const RsvpForm = () => {
  useEffect(() => {
    // Load Luma checkout script
    const script = document.createElement('script');
    script.id = 'luma-checkout';
    script.src = 'https://embed.lu.ma/checkout-button.js';
    script.async = true;
    document.body.appendChild(script);
    return () => {
      const existingScript = document.getElementById('luma-checkout');
      if (existingScript) {
        document.body.removeChild(existingScript);
      }
    };
  }, []);
  return <section id="rsvp" className="bg-blush bg-opacity-20 py-20" data-id="element-132">
      <div className="section-container" data-id="element-133">
        <h2 className="section-heading" data-id="element-134">RSVP</h2>
        <p className="text-center text-gray-700 max-w-2xl mx-auto mb-10" data-id="element-135">
          We would be honored to have you join us on our special day. Please
          register your attendance to receive venue details and updates.
        </p>
        <div className="max-w-2xl mx-auto text-center" data-id="element-136">
          <a href="https://luma.com/event/evt-T1FUzQc06v9aZvI" className="luma-checkout--button inline-block px-10 py-4 bg-gold text-white font-sans text-base uppercase tracking-wider hover:bg-opacity-90 transition-all duration-300 shadow-md" data-luma-action="checkout" data-luma-event-id="evt-T1FUzQc06v9aZvI" data-id="element-137">
            RSVP - Join Us Celebrate
          </a>
        </div>
      </div>
    </section>;
};
export default RsvpForm;